import React from "react";
import PropTypes from "prop-types";
import { DataTable } from "MODULES/shared/components";
import get from "lodash/get";
import { properCase } from "LIB/formatters/text";

// Utility function to remove time from date string
const formatDateWithoutTime = dateStr => {
  const date = new Date(dateStr);
  return isNaN(date) ? dateStr : date.toLocaleDateString(); // Fallback to original if date is invalid
};

const AuditTrail = ({ company, isLoading }) => {
  const renderPreviousValue = row => {
    if (!row.previous_value) {
      return null;
    }
    return row.action === "business_start_date"
      ? formatDateWithoutTime(row.previous_value)
      : properCase(row.previous_value);
  };

  const renderRow = row => (
    <tr key={row.created_at}>
      <td>{new Date(row.created_at).toLocaleDateString()}</td>
      <td>{new Date(row.created_at).toLocaleTimeString()}</td>
      <td>{properCase(row.action)}</td>
      <td>{row.created_by && row.created_by.full_name}</td>
      <td>{renderPreviousValue(row)}</td>
      <td>
        {row.action === "business_start_date"
          ? formatDateWithoutTime(row.new_value)
          : properCase(row.new_value)}
      </td>
    </tr>
  );

  const auditTrails = get(company.toJS(), "audit_trails", []);

  return (
    <div>
      <h2>Audit Trail</h2>

      <DataTable.Mini loading={isLoading}>
        <DataTable.Head>
          <th>Date</th>
          <th>Time</th>
          <th>Action</th>
          <th>User</th>
          <th>Previous Value</th>
          <th>New Value</th>
        </DataTable.Head>
        <DataTable.Body>
          {auditTrails.length > 0 ? (
            auditTrails.map(renderRow)
          ) : (
            <tr>
              <td colSpan="6" className="text-center">
                No records found.
              </td>
            </tr>
          )}
        </DataTable.Body>
      </DataTable.Mini>
    </div>
  );
};

AuditTrail.propTypes = {
  company: PropTypes.shape({
    audit_trails: PropTypes.arrayOf(
      PropTypes.shape({
        created_at: PropTypes.string.isRequired,
        action: PropTypes.string,
        created_by: PropTypes.shape({
          full_name: PropTypes.string
        }),
        previous_value: PropTypes.string,
        new_value: PropTypes.string
      })
    )
  }).isRequired,
  isLoading: PropTypes.bool.isRequired
};

export default AuditTrail;



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/AuditTrail/AuditTrail.jsx